import { Dayjs } from "dayjs";
import { ICaseInformation } from "us.collection.case/reducers/CaseInformation/Interfaces";
import { DateNames } from "../Constants";

export const disabledDate = (
  current: Dayjs,
  dateField: keyof ICaseInformation,
  dueDate: Dayjs | undefined,
  noOfDaysDueDateToDWDate: number,
) => {
  try {
    if (!dueDate || !current) return false;
    if (dateField === DateNames.OBSOLETE_DATE){
      return current && current < dueDate.endOf("day");
    }
    if (dateField === DateNames.DW_DATE && noOfDaysDueDateToDWDate) {
      const minValidDate = dueDate.clone().add(noOfDaysDueDateToDWDate, "days");
      return current.isBefore(minValidDate, "day");
    }
    return false;    
  } catch (error) {
      return false; 
  }
};


